import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { ToastHost } from "./toast";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <ToastHost />
  </StrictMode>,
);
